import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { quoteFormSelector } from 'ctm-selectors';
import { displayBooleanString } from 'ctm-util-functions';
import { QuoteCard } from '../quote_card';
import { QuoteQuestionPlainItem } from '../quote_question_plain_item';

const _AccessoriesDetails = (props) => {
    const { factoryOptions, nonStandardAccessories, modified, autoProgressToResults } = props;
    const hasNonStandardAccessories = !!nonStandardAccessories && nonStandardAccessories.size > 0;
    const hasFactoryOptions = !!factoryOptions && factoryOptions.size > 0;

    const handleEditClick = () => {
        autoProgressToResults();
    };

    return (
        <QuoteCard title="Accessories" path="factory_options" onEditClick={handleEditClick}>
            <QuoteQuestionPlainItem title="Factory Options" content={displayBooleanString(hasFactoryOptions)} />
            <QuoteQuestionPlainItem title="Non-standard Accessories" content={displayBooleanString(hasNonStandardAccessories)} />
            <QuoteQuestionPlainItem title="Modified" content={displayBooleanString(modified)} />
        </QuoteCard>
    );
};

_AccessoriesDetails.propTypes = {
    factoryOptions: PropTypes.any,
    nonStandardAccessories: PropTypes.any,
    modified: PropTypes.string,
    autoProgressToResults: PropTypes.func
};

const mapStateToProps = (state) => {
    return {
        factoryOptions: quoteFormSelector(state).getIn(['coverDetail', 'vehicle', 'factoryOptions']),
        nonStandardAccessories: quoteFormSelector(state).getIn(['coverDetail', 'vehicle', 'nonStandardAccessories']),
        modified: quoteFormSelector(state).getIn(['coverDetail', 'vehicle', 'modified'])
    };
};

// @see packages/ctm-vertical-car/components/results/edit_my_details/edit_my_details.js line-221
const dispatchMapping = (dispatch) => ({
    autoProgressToResults: () => {
        dispatch({
            type: 'SET_VALUE',
            identifier: 'helpers.isEditingAccessories',
            value: true,
            stateKey: 'vertical.quote'
        });
    }
});

const AccessoriesDetails = connect(mapStateToProps, dispatchMapping)(_AccessoriesDetails);

export { AccessoriesDetails, _AccessoriesDetails };
